module.exports = __webpack_public_path__ + "static/img/img_ptyw2.b8f7480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_ptyw2.png
// module id = rXdu
// module chunks = 19